import type { FaireProductEntity } from "../../entity_types/product";

export const p_v58y9erx46: FaireProductEntity = {
  token: "p_v58y9erx46",
  type: "product",
  name: "Personalized Youth Fleece Full-Zip Hooded Sweatshirt",
  brandToken: "b_4adj9wfm65",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/892a25d083483a1ea5bcaf596f42ab5f69c9e40e9386f828e990e7c2103fd815.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05596d45e65d3bddfddaec98217a3ba8916f908e4620d9aeee28f58e738d28f6.jpeg",
    "https://cdn.faire.com/fastly/95365bc5b5256a83af55434e0bb43264b6e06f87962ed20c72d21e60d1d765b1.jpeg",
    "https://cdn.faire.com/fastly/c1fedd005b2eaa4684a9c21129892c67f1a74642522170b5b3fc1898c7fa08a9.jpeg",
    "https://cdn.faire.com/fastly/0b05929ec28068af6c4b006d0e5b0f25eb9b74e7bd97fc1037b20577af20ca88.jpeg",
    "https://cdn.faire.com/fastly/a86231ed2fd0ee5b18a39dcce4adf85a4bb262c40d5e394dc73263aeddccc682.jpeg",
  ],
  priceDollars: 24.93,
  description:
    "Order these blank or personalized!\n\nThis is the perfect monogrammed item to keep even the littler members of your family warm. This full-zip, hooded sweatshirt features rib knit cuffs and waistband as well as front pouch pockets.\n\nAll names are printed in commercial grade white vinyl and will not crack or fade!\n\n7.8-ounce, 50/50 cotton/poly fleece\nAir jet yarn for a soft, pill-resistant finish",
  tags: [],
  msrpDollars: 49.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:43.112Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
